import { SVGProps } from 'react';

const IcTime = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none' {...props}>
      <path
        d='M9.9987 19.1667C8.18571 19.1667 6.41342 18.6291 4.90597 17.6218C3.39852 16.6146 2.22361 15.183 1.52981 13.508C0.836003 11.833 0.654472 9.98987 1.00817 8.21172C1.36187 6.43356 2.23491 4.80021 3.51689 3.51823C4.79887 2.23625 6.43221 1.36321 8.21037 1.00951C9.98853 0.655815 11.8316 0.837346 13.5066 1.53115C15.1816 2.22495 16.6133 3.39987 17.6205 4.90732C18.6278 6.41477 19.1654 8.18705 19.1654 10C19.1654 12.4312 18.1996 14.7628 16.4805 16.4819C14.7614 18.2009 12.4299 19.1667 9.9987 19.1667ZM9.9987 2.1429C8.44471 2.1429 6.92561 2.60372 5.63351 3.46707C4.34141 4.33042 3.33434 5.55754 2.73965 6.99325C2.14496 8.42895 1.98936 10.0088 2.29253 11.5329C2.5957 13.057 3.34402 14.457 4.44286 15.5559C5.5417 16.6547 6.94171 17.403 8.46585 17.7062C9.98998 18.0094 11.5698 17.8538 13.0055 17.2591C14.4412 16.6644 15.6683 15.6573 16.5317 14.3652C17.395 13.0731 17.8558 11.554 17.8558 10C17.8558 7.9162 17.028 5.91771 15.5545 4.44421C14.081 2.97071 12.0825 2.1429 9.9987 2.1429Z'
        fill='#37A0AA'
      />
      <path
        d='M13.0041 13.9286L9.34394 10.2685V4.10719H10.6535V9.72504L13.9273 13.0054L13.0041 13.9286Z'
        fill='#37A0AA'
      />
    </svg>
  );
};

export default IcTime;
